import type { FC, ReactNode } from 'react';
import { Button, ComposedModal, FeatureFlags, InlineLoading, ModalBody, ModalFooter, ModalHeader, RadioTile, Stack, TileGroup } from '@carbon/react';
import { Document as IconeDeDocumento } from '@carbon/icons-react';

import { MODELOS_DO_PDF, type ModeloDoPdf } from '../../../logica/pdf/modelos';
import { ROTULOS } from '../rotulos';
import { MiniaturaDoPdf } from './MiniaturaDoPdf';
import styles from './ModeloDoPdf.module.scss';

// O BANCO DE MODELOS DO PDF, o mesmo para todo documento que se exporta (o branding, o diagnóstico):
// a miniatura de cada modelo, o nome e para que serve, e o botão que gera. Os textos são do
// documento; o estado (`EstadoDoPdf`) vem da lógica dele.

export interface EstadoDoPdf {
  gerando: boolean;
  aberto: boolean;
  abrir: () => void;
  fechar: () => void;
  modelo: ModeloDoPdf;
  escolher: (m: ModeloDoPdf) => void;
  exportar: () => void;
}

export interface TextosDoModeloDoPdf {
  titulo: string;
  escolha: string;
  gerar: string;
  cancelar: string;
  gerando: string;
  classico: { nome: string; texto: string };
  noite: { nome: string; texto: string };
  revista: { nome: string; texto: string };
}

export const ModeloDoPdfModal: FC<{ p: EstadoDoPdf; textos: TextosDoModeloDoPdf; kicker: string; cores?: string[]; aviso?: ReactNode }> = ({ p, textos, kicker, cores = [], aviso }) => (
  <FeatureFlags enableFocusWrapWithoutSentinels>
    <ComposedModal open={p.aberto} onClose={p.fechar} size='md'>
      <ModalHeader label={kicker} title={textos.titulo} closeModal={p.fechar} iconDescription={ROTULOS.fechar} />
      <ModalBody>
        <Stack gap={5}>
          {aviso}
          <TileGroup name={`modelo-do-pdf-${kicker}`} legend={textos.escolha} valueSelected={p.modelo} onChange={(v) => p.escolher(v as ModeloDoPdf)} className={styles.modelosDoPdf}>
            {MODELOS_DO_PDF.map((m) => (
              <RadioTile key={m} id={`modelo-do-pdf-${kicker}-${m}`} value={m} className={styles.modeloDoPdf} disabled={p.gerando}>
                <span className={styles.corpoDoModelo}>
                  <MiniaturaDoPdf modelo={m} cores={cores} />
                  <span className={styles.nomeDoModelo}>{textos[m].nome}</span>
                  <span className={styles.textoDoModelo}>{textos[m].texto}</span>
                </span>
              </RadioTile>
            ))}
          </TileGroup>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button kind='secondary' onClick={p.fechar} disabled={p.gerando}>{textos.cancelar}</Button>
        {p.gerando
          ? <InlineLoading status='active' description={textos.gerando} iconDescription={textos.gerando} className={styles.gerandoPdf} />
          : <Button kind='primary' renderIcon={IconeDeDocumento} onClick={p.exportar}>{textos.gerar}</Button>}
      </ModalFooter>
    </ComposedModal>
  </FeatureFlags>
);
